/* global axios */
import ApiClient from './ApiClient';

class Mres3API extends ApiClient {
  constructor() {
    super('mres3_connections', { accountScoped: true });
  }

  catalog(connectionId) {
    return axios.get(`${this.url}/${connectionId}/catalog`);
  }

  summary(connectionId) {
    return axios.get(`${this.url}/${connectionId}/summary`);
  }

  records(connectionId, entity, params = {}) {
    if (params.mres3_query) {
      return axios.post(
        `${this.url}/${connectionId}/records/${entity}/search`,
        params
      );
    }
    return axios.get(`${this.url}/${connectionId}/records/${entity}`, {
      params,
    });
  }
}

export default new Mres3API();
